import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, Button } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';
import UsernameInput from 'components/UsernameInput';
import { isEmail, addLeadingZeros } from 'utils/functions';

const LoginForm = ({ className, handleSubmit, disabled }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { t } = useTranslation('Login');

  return (
    <div className={className} data-testid="loginForm">
      <form
        className="login-form"
        onSubmit={e =>
          handleSubmit(
            e,
            isEmail(username) ? username : addLeadingZeros(username),
            password
          )
        }
        data-testid="login_form"
      >
        <div className="login-form__inputs-container">
          <UsernameInput
            value={username}
            handleSetValue={setUsername}
            disabled={disabled}
          />
          <label
            className="login-form__label visually-hidden"
            htmlFor="password"
          >
            {t('password')}
          </label>
          <Field
            id="password"
            name="password"
            label={t('password')}
            className="login-form__input"
            type="password"
            value={password}
            size="M"
            disabled={disabled}
            onChange={(_, input) => setPassword(input.value)}
          />
        </div>
        <Button
          data-testid="login_submit"
          className="login-form__submit"
          type="submit"
          skin="primary"
          disabled={disabled || username === '' || password === ''}
          text={t('login')}
        />
      </form>
    </div>
  );
};

LoginForm.defaultProps = {
  disabled: false
};

LoginForm.propTypes = {
  className: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default LoginForm;
